class TourismInsurancePriceRequest {
  companyid = null;
  currency = null;
  plantype = null;
  // kumdahiltype = false;
  createdby = null;
  updatedby = null;
}
export default TourismInsurancePriceRequest;
